var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
var Icon = require('./wrappers/ReUpIcon');
var ShadowView = require('./ShadowView.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
} = ReactNative;

var TransactionResult = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
    }
  },

  componentDidMount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  render: function()
  {

    // {
    //     "jsonrpc": "2.0",
    //     "error": {
    //         "code": -11,
    //         "message": "NSF -- Not enough credit",
    //         "usermsg": "",
    //         "AppStoreURL": "",
    //         "PlayStoreURL": ""
    //     },
    //     "result": {
    //         "FirstName": "ReUp",
    //         "LastName": "Scanner",
    //         "UserCredit": "0.00",
    //         "Total": 0.08
    //     },
    //     "info": {
    //         "Profile": 0.0451028347015
    //     },
    //     "ID": 1
    // }

    var appManager = this.props.appManager;
    appManager._lastTransaction = this.props.extras;
    var thisThing = this;
    var appActions = this.props.appActions;
    var textStyle1 = {fontSize:18};
    var textStyle2 = {fontSize:22, fontWeight:'bold'};
    var locMan = this.props.appManager.getLocalizationManager();
    var assignPointsHeader = locMan.localizedStringForKey("ASSIGN_POINTS_HEADER");
    var successHeader = locMan.localizedStringForKey("SUCCESS_HEADER");
    var purchaseHeader = locMan.localizedStringForKey("PURCHASE_HEADER");
    var rewardHeader = locMan.localizedStringForKey("REWARD_HEADER");
    var redeemedHeader = locMan.localizedStringForKey("REDEEMED_HEADER");
    var passHeader = locMan.localizedStringForKey("PASS_HEADER");
    var transferHeader = locMan.localizedStringForKey("TRANSFER_HEADER");
    var creditAddHeader = locMan.localizedStringForKey("CREDIT_ADD_HEADER");
    if( this.props.extras.success )
    {
      var userCurrentCredit = locMan.localizedStringForKeyAndParams("USERS_CREDIT_LABEL", [locMan.localizedDollars(this.props.extras.UserCredit)]);
      var headerBlurb = this.props.extras.isCheckin ? (assignPointsHeader+"\n"+successHeader) : (purchaseHeader+"\n"+successHeader);
      var headerColor = this.props.extras.isCheckin ? "blue" : "green";
      var iconName = "usd";
      if( this.props.extras.isCheckin ) iconName = "map-marker";
      if( this.props.extras.isReward )
      {
        iconName = "star";
        headerColor = "purple";
        headerBlurb = rewardHeader+"\n"+redeemedHeader;
      }
      if( this.props.extras.isPass )
      {
        iconName = "ticket";
        headerColor = "green";
        headerBlurb = passHeader+"\n"+redeemedHeader;
      }
      if( this.props.extras.isTransfer )
      {
        iconName = "exchange";
        headerColor = "black";
        headerBlurb = transferHeader+"\n"+successHeader;
      }
      if( this.props.extras.isAddingCredit )
      {
        iconName = "usd";
        headerColor = "green";
        headerBlurb =  creditAddHeader+"\n"+successHeader;
      }

      var tipTotalIsNotZero = typeof this.props.extras.TipTotal !== 'undefined' && this.props.extras.TipTotal > 0;

      return (
        <View style={[styles.container, {flexDirection:'column'}]}>
            <View style={{flexDirection:'column', flex:1}}>
              <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center', flex:1, backgroundColor:headerColor}}>
                <View style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                  <ReUpText style={{fontSize:22, fontWeight:'bold', color:'white'}}>{headerBlurb}</ReUpText>
                </View>
                <View style={{flex:1, alignItems:'center', justifyContent:'center', }}>
                  <Icon pointerEvents="none" name={iconName} size={96} color={"white"} />
                </View>
              </View>
              <ShadowView layout={this.state.layout} appManager={appManager}/>

              <View style={{flexDirection:'column', justifyContent:'center', flex:2, padding:10}}>
                <ScrollView style={{flex:1}}>
                  {
                    typeof this.props.extras.reward !== 'undefined' ?
                    <View style={{flexDirection:'column', padding:8, alignItems:'center', justifyContent:'center'}}>
                      <ReUpText style={textStyle2}>{this.props.extras.reward.RewardName}</ReUpText>
                      <ReUpText style={textStyle2}>{locMan.localizedPoints(this.props.extras.reward.Points)}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.PassName !== 'undefined' && typeof this.props.extras.PassQuantityRemaining !== 'undefined' ?
                    <View style={{flexDirection:'column', padding:8, alignItems:'center', justifyContent:'center'}}>
                      <ReUpText style={textStyle2}>{this.props.extras.PassName}</ReUpText>
                      <ReUpText style={textStyle2}>{this.props.extras.PassQuantityRemaining + " Remaining."}</ReUpText>
                    </View> : null
                  }

                  {
                    typeof this.props.extras.Subtotal !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText style={textStyle1}>{locMan.localizedStringForKey("SUBTOTAL_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText style={textStyle1}>{locMan.localizedDollars(this.props.extras.Subtotal)}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.ServiceFee !== 'undefined' ?
                    <View style={{marginLeft:30, flexDirection:'row'}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("SERVICE_FEE_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{locMan.localizedDollars(this.props.extras.ServiceFee)}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.TipTotal !== 'undefined' ?
                    <View style={{marginLeft:30, flexDirection:'row', backgroundColor:tipTotalIsNotZero? 'yellow' : 'transparent'}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("TIP_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{locMan.localizedDollars(this.props.extras.TipTotal)}</ReUpText>
                    </View> : null
                  }
                  <View style={{backgroundColor:'black', height:2, marginLeft:30, marginBottom:10}} />
                  {
                    typeof this.props.extras.CreditUsed !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText  style={[textStyle1, {fontWeight:'bold'}]}>{locMan.localizedStringForKey("TOTAL_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={[textStyle1, {fontWeight:'bold'}]}>{locMan.localizedDollars(this.props.extras.CreditUsed)}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.CreditAdded !== 'undefined' ?
                    <View style={{flexDirection:'row', marginTop:20}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("CREDIT_ADDED_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{locMan.localizedDollars(this.props.extras.CreditAdded)}</ReUpText>
                    </View> : <View style={{height:20}} />
                  }
                  {
                    typeof this.props.extras.PointsEarned !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("POINTS_EARNED_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{locMan.localizedPoints(this.props.extras.PointsEarned)}</ReUpText>
                    </View> : null
                  }
                  <ShadowView layout={this.state.layout} appManager={appManager}/>
                  {
                    typeof this.props.extras.TransactionID !== 'undefined' ?
                    <View style={{flexDirection:'row', marginTop:20}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("TRANSACTION_ID_LABEL_2")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{this.props.extras.TransactionID}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.UserName !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText style={textStyle1}>{this.props.extras.UserName.indexOf("@") >= 0 ? (locMan.localizedStringForKey("EMAIL_LABEL")) : (locMan.localizedStringForKey("PHONE_NUMBER_LABEL"))}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText style={textStyle1}>{this.props.extras.UserName.indexOf("@") >= 0 ? this.props.extras.UserName : locMan.localizedPhone(this.props.extras.UserName)}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.GCID !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText style={textStyle1}>{locMan.localizedStringForKey("GIFT_CARD_ID_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText style={textStyle1}>{this.props.extras.GCID}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.FirstName !== 'undefined' && typeof this.props.extras.LastName !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText style={textStyle1}>{locMan.localizedStringForKey("NAME_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText style={textStyle1}>{this.props.extras.FirstName + " " + this.props.extras.LastName}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.CurrentCredit !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("CURRENT_CREDIT_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{locMan.localizedDollars(this.props.extras.CurrentCredit)}</ReUpText>
                    </View> : null
                  }
                  {
                    typeof this.props.extras.CurrentPoints !== 'undefined' ?
                    <View style={{flexDirection:'row'}}>
                      <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("CURRENT_POINTS_LABEL")}</ReUpText>
                      <View style={{flex:1}}/>
                      <ReUpText  style={textStyle1}>{locMan.localizedPoints(this.props.extras.CurrentPoints)}</ReUpText>
                    </View> : null
                  }
                </ScrollView>
                <ReUpButton isSecondary={true} style={[styles.button,{margin:10}]}
                  appManager={appManager}
                  text={locMan.localizedStringForKey("SCAN_NEW_BUTTON")}
                  onPress={() =>
                  {
                    thisThing.props.appActions.requestPopToIndex(1);
                    if( typeof thisThing.props.extras.scanner !== 'undefined' )
                    {
                      setTimeout(function()
                      {
                        thisThing.props.extras.scanner.scan();
                      },300)
                    }
                  }}
                  />
              </View>
            </View>
        </View>
      );
    }
    else
    {
      var errorAcronym = this.props.extras.code == -11 ? "NSF" : (this.props.extras.code == -3 ? "ERR" : "NSP");

      var userCurrentCredit = this.props.extras.code == -3 ? "" : locMan.localizedStringForKeyAndParams("USERS_CREDIT_LABEL", [this.props.appManager.getLocalizationManager().localizedDollars(this.props.extras.result.UserCredit)], "User's Credit: %0%");
      return (
        <View style={[styles.container, {flexDirection:'column'}]}>
            <View style={{flexDirection:'column', flex:1}}>
              <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center', flex:1, backgroundColor:'red'}}>
                <View style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                  <ReUpText style={{fontSize:64, fontWeight:'bold', color:'white'}}>{errorAcronym}</ReUpText>
                </View>
                <View style={{flex:1, alignItems:'center', justifyContent:'center', }}>
                  <Icon pointerEvents="none" name={"times"} size={96} color={"white"} />
                </View>
              </View>
              <ShadowView layout={this.state.layout} appManager={appManager}/>

              <View style={{flexDirection:'column', justifyContent:'center', flex:2, padding:10}}>

                {
                  typeof this.props.extras.message !== 'undefined' ?
                  <ReUpText style={{fontSize:22, color:'black'}}>{this.props.extras.message}</ReUpText> : null
                }
                <ShadowView layout={this.state.layout} appManager={appManager}/>
                {
                  typeof this.props.extras.result.FirstName !== 'undefined' && typeof this.props.extras.result.LastName !== 'undefined' ?
                  <View style={{flexDirection:'row', marginTop:20}}>
                    <ReUpText style={textStyle1}>{locMan.localizedStringForKey("NAME_LABEL")}</ReUpText>
                    <View style={{flex:1}}/>
                    <ReUpText style={textStyle1}>{this.props.extras.result.FirstName + " " + this.props.extras.result.LastName}</ReUpText>
                  </View> : null
                }
                {
                  typeof this.props.extras.result.CurrentCredit !== 'undefined' ?
                  <View style={{flexDirection:'row'}}>
                    <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("CURRENT_CREDIT_LABEL")}</ReUpText>
                    <View style={{flex:1}}/>
                    <ReUpText  style={textStyle1}>{locMan.localizedDollars(this.props.extras.result.CurrentCredit)}</ReUpText>
                  </View> : null
                }
                {
                  typeof this.props.extras.result.UserCredit !== 'undefined' ?
                  <View style={{flexDirection:'row'}}>
                    <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("CURRENT_CREDIT_LABEL")}</ReUpText>
                    <View style={{flex:1}}/>
                    <ReUpText  style={textStyle1}>{locMan.localizedDollars(this.props.extras.result.UserCredit)}</ReUpText>
                  </View> : null
                }
                {
                  typeof this.props.extras.result.CurrentPoints !== 'undefined' ?
                  <View style={{flexDirection:'row'}}>
                    <ReUpText  style={textStyle1}>{locMan.localizedStringForKey("CURRENT_POINTS_LABEL", "Current Credit:")}</ReUpText>
                    <View style={{flex:1}}/>
                    <ReUpText  style={textStyle1}>{locMan.localizedPoints(this.props.extras.result.CurrentPoints)}</ReUpText>
                  </View> : null
                }
                <View style={{flex:1}} />
                <ReUpButton isSecondary={true} style={[styles.button,{margin:10}]}
                  appManager={appManager}
                  text={locMan.localizedStringForKey("SCAN_NEW_BUTTON")}
                  onPress={() =>
                  {
                    thisThing.props.appActions.requestPopToIndex(1);
                    if( typeof thisThing.props.extras.scanner !== 'undefined' )
                    {
                      setTimeout(function()
                      {
                        thisThing.props.extras.scanner.scan();
                      },300)
                    }
                  }}
                  />
              </View>


            </View>
        </View>
      );
    }
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});


TransactionResult.dataDependencies = []

module.exports = TransactionResult;
